export const TABLE_BAND_TYPE = Symbol('band');
export const BAND_GROUP_CELL = 'bandGroupCell';
export const BAND_HEADER_CELL = 'bandHeaderCell';
export const BAND_EMPTY_CELL = 'bandEmptyCell';
export const BAND_DUPLICATE_RENDER = 'bandDuplicateRender';
